import React, { useState } from "react"; 
import { FaBars, FaTimes } from "react-icons/fa"; 
import { Link } from "react-router-dom"; 
import "../Navbar.css"; 
import logo from "../assets/logo.jpg"; 

const Navbar = () => {
  const [nav, setNav] = useState(false); 

  // Liens pour la navigation
  const linksLeft = [
    { id: 1, link: "Nos valeurs", path: "/nos-valeurs" },
    { id: 2, link: "Nos réalisations", path: "/nos-realisations" },
  ];

  const linksRight = [
    { id: 3, link: "Nos métiers", path: "/nos-metiers" },
    { id: 4, link: "Contact", path: "/#contact" }, // Utiliser ancre #contact
  ];

  return (
    <div className="navbar">
      {/* Liens à gauche */}
      <div className="navbar-left">
        <ul className="nav-links">
          {linksLeft.map(({ id, link, path }) => (
            <li key={id} className="nav-item">
              <Link to={path} className="nav-link">{link}</Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Logo centré */}
      <div className="navbar-logo">
        <Link to="/">
          <img src={logo} alt="Logo" className="logo" />
        </Link>
      </div>

      {/* Liens à droite */}
      <div className="navbar-right">
        <ul className="nav-links">
          {linksRight.map(({ id, link, path }) => (
            <li key={id} className="nav-item">
              <Link to={path} className="nav-link">{link}</Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Menu Burger */}
      <div className="menu-icon" onClick={() => setNav(!nav)}>
        {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
      </div>

      {/* Menu mobile */}
      {nav && (
        <ul className="mobile-menu">
          {linksLeft.concat(linksRight).map(({ id, link, path }) => (
            <li key={id} className="mobile-nav-item">
              <Link to={path} className="mobile-nav-link" onClick={() => setNav(false)}>{link}</Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Navbar;
